import { Text, useTranslation } from '@obvio/app'
import {
  CheckboxInput,
  Form,
  FormPage,
  GridItem,
  Stack,
  Submit,
  TextArea,
  TextInput,
} from '@obvio/ui'
import { Label } from '@obvio/ui/Form/Inputs/utils'

import { GridSubmit } from './components'
import { FormBarMargin } from './FormJoin/FormSection'
import { FadeIn } from '../FadeIn'

import type { ReactElement } from 'react'

export function FormAdvisor(): ReactElement {
  const { t } = useTranslation()
  return (
    <Form>
      <FormPage>
        <FadeIn>
          <FormBarMargin title="Your professional details" />
          <Stack kind="vertical">
            <TextInput name="name" label="Full name" />
            <TextInput name="email" label="Email address" />
            <TextInput name="phone" label="Phone number" />
            <TextInput name="site" label="Website" optional />
            <TextInput name="linkedin" label="Linkedin" optional />
            <TextInput name="resume" label="Resume url" />
            <TextArea name="message" label="Message" rows={10} />
            <Label inputKind="textarea">Interest areas</Label>
            <Stack spacing="medium" mobileKind="vertical">
              <CheckboxInput
                name="buildUpCollection"
                label="Build up collection"
              />
              <CheckboxInput
                name="artistManagement"
                label="Artist management"
              />
              <CheckboxInput
                name="collectionManagement"
                label="Collection management"
              />
              <CheckboxInput name="other" label="Other" />
            </Stack>
            <GridSubmit templateColumns="1fr 1fr" gap="medium">
              <GridItem>
                <CheckboxInput name="rodo" label={t('form.rodo')} required />
              </GridItem>
              <GridItem noCenter>
                <Submit>SEND APPLICATION</Submit>
              </GridItem>
            </GridSubmit>
          </Stack>
        </FadeIn>
      </FormPage>
      <FormPage>
        <FadeIn>
          <Text tag="h2" as="h4">
            {t('joinForm.sent')}
          </Text>
        </FadeIn>
      </FormPage>
    </Form>
  )
}
